import React from 'react';
import { Button, Space, Typography } from 'antd';
import { DeleteOutlined, FileOutlined, WarningOutlined } from '@ant-design/icons';

const { Text } = Typography;

const MEGABYTE = 1000000;
const MAX_FILE_SIZE = 3 * MEGABYTE;

export const File = ({ file, deleteFile, variant }) => {
    const isOversized = file.size >= MAX_FILE_SIZE;
    const sizeLabel = (file.size / Math.pow(10, 6)).toFixed(2) + ' MB';

    return (
        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Space>
                {isOversized ? (
                    <WarningOutlined style={{ color: '#faad14' }} />
                ) : (
                    <FileOutlined style={{ color: '#8c8c8c' }} />
                )}
                <Text style={{ color: isOversized ? '#ff4d4f' : undefined }}>{file.name}</Text>
                <Text type="secondary">{sizeLabel}</Text>
                {isOversized && <Text type="warning">File too large</Text>}
            </Space>
            <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => deleteFile(variant.id, file.uuid)}
            />
        </Space>
    );
};
